import React from "react"
import PropTypes from "prop-types"
import { Typography } from "@mui/material"
import { PADDING_HORIZONTAL, PADDING_VERTICAL } from "./dynamicTextarea.constants"

const DynamicTextareaLabel = ({ label, labelId, shrink, centerWhenResting }) => (
    <Typography
        id={labelId}
        component="span"
        variant="body2"
        data-dynamic-textarea-label
        sx={{
            position: "absolute",
            zIndex: 1,
            left: PADDING_HORIZONTAL,
            top: shrink ? 8 : centerWhenResting ? "50%" : "14px",
            transform: shrink || !centerWhenResting ? "none" : "translateY(-50%)",
            fontSize: shrink ? "10px" : "14px",
            lineHeight: shrink ? "16px" : `${PADDING_VERTICAL}px`,
            height: shrink ? "16px" : `${PADDING_VERTICAL}px`,
            display: "flex",
            alignItems: shrink ? "flex-start" : "center",
            color: "common.white",
            opacity: 0.8,
            pointerEvents: "none",
            transition: "all 0.15s ease",
        }}
    >
        {label}
    </Typography>
)

DynamicTextareaLabel.propTypes = {
    label: PropTypes.string.isRequired,
    labelId: PropTypes.string.isRequired,
    shrink: PropTypes.bool.isRequired,
    centerWhenResting: PropTypes.bool,
}

DynamicTextareaLabel.defaultProps = {
    centerWhenResting: false,
}

export default DynamicTextareaLabel
